<template>
  <div>
    <div class="table_form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="消息类型">
          <el-select
            v-model="formInline.noticeType"
            placeholder="请选择"
            size="mini"
            style="display: flex;flex-direction: column;"
          >
            <el-option  v-for="item in dictList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            size="mini"
            v-model="formInline.noticeTitle"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit"
            >查询</el-button
          >
          <el-button size="mini" @click="reset">重置</el-button>
          <!-- <el-button size="mini" @click="addMsg">新增</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div>
      <!-- <el-button
        size="mini"
        type="primary"
        @click="readAllMsgBtn"
        :disabled="noReadList.length === 0"
        >全部已读</el-button
      > -->
      <el-button size="mini" @click="deleteOpen = true" :disabled="multipleSelection.length === 0">批量删除</el-button>
    </div>
    <div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column prop="read_flag" label="消息内容" align="center">
          <template #default="scope">
            <span>{{ scope.row.notice_content ||scope.row.notice_title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="msg_type_name" label="消息类型" align="center">
        </el-table-column>
        <el-table-column
          prop="send_time"
          label="提交时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="receive_user_name"
          label="接收人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sender_username"
          label="提交人"
          align="center"
        ></el-table-column>
        <el-table-column prop="read_flag" label="状态" align="center">
          <template #default="scope">
            <span v-if="scope.row.read_flag == '1'">已读</span>
            <span v-if="scope.row.read_flag == '0'">未读</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <div style="width: 480px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="getMsgList"
          :current-page.sync="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size.sync="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="open" width="30%">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="提交人" prop="sender_username">
          <el-input v-model="ruleForm.sender_username" disabled></el-input>
        </el-form-item>
        <el-form-item label="接收人" prop="receive_user_name">
          <el-input v-model="ruleForm.receive_user_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="消息类型" prop="notice_type">
          <el-select
            v-model="ruleForm.notice_type"
            placeholder="请选择消息类型"
            disabled
          >
          <el-option  v-for="item in dictList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="消息标题" prop="notice_title">
          <el-input v-model="ruleForm.notice_title" disabled></el-input>
        </el-form-item> -->
        <el-form-item label="消息内容" prop="disabled">
          <el-input
            disabled
            type="textarea"
            v-model="ruleForm.disabled"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="title === '新增站内通知'">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提醒" :visible.sync="deleteOpen" width="20%" center="">
      <span>消息删除后不可恢复，确认删除吗？</span
      ><span slot="footer" class="dialog-footer">
        <el-button @click="deleteOpen = false">取 消</el-button>
        <el-button type="primary" @click="deleteControl"
          >确 定</el-button
        >
      </span></el-dialog
    >
  </div>
</template>

<script>
import {
  getMsgList,
  getMsgInfo,
  sendMsg,
  readMsg,
  readAllMsg,
  removeMsg,
} from "@/api/message";
import { dictData } from '@/api/dict'
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      multipleSelection: [],
      total: 0,
      queryParams: {
        pageSize: 10,
        pageNum: 1,
        readFlag:"1"
      },
      title: "查看站内通知详情",
      open: false,
      ruleForm: {},
      noReadList: [],
      deleteOpen: false,
      dictList:[]
    };
  },
  mounted() {
    this.getDictList()
    this.getMsgList();
  },
  methods: {
    deleteControl(){
        let idList = this.multipleSelection.map(item => {
            return item.send_id
        })
        const formData = new FormData()
        let val = idList.toString()
        formData.append('ids',val)
        removeMsg(formData).then(res => {
            if(res.code == 0) {
            this.$message.success('删除消息成功！')}
            else this.$message.error('删除信息失败！')
        })
        this.deleteOpen = false
        this.getMsgList()
    },
    // readAllMsgBtn() {
    //   readAllMsg().then((res) => {
    //     if (res.code == "0") {
    //       this.$message.success("全部已读成功！");
    //       this.getMsgList();
    //     } else this.$message.error("全部已读失败！");
    //   });
    // },
    // addMsg(){
    //     this.title = "新增站内通知";
    //     this.open = true
    // },
    submit() {
      this.open = false;
      console.log(this.ruleForm);
    },
    close() {
      this.open = false;
      this.ruleForm = {};
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    getMsgList() {
      if (this.formInline.noticeType == "0") this.formInline.noticeType = "";
      let params = {
        ...this.queryParams,
        ...this.formInline,
      };
      getMsgList(params).then((res) => {
        this.tableData = res.rows;
        this.total = res.total;
        this.noReadList = [];
        res.rows.filter((item) => {
          if (item.read_flag === "0") this.noReadList.push(item);
        });
      });
    },
    handleDetail(val) {
      this.ruleForm = val;
      console.log(val);
      this.open = true;
    },
    onSubmit() {
      this.getMsgList();
    },
    reset() {
      Object.keys(this.formInline).forEach(key => {
        this.formInline[key] = ''
        this.getMsgList()
      }) 
    },
    awardChange() {},
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getDictList() {
      dictData({pageNum:1,pageSize:1000,dictType:'sys_notice'}).then(res => {
        this.dictList = res
    })
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/MessageModule/ReadMessage.vue